<script>
export default {
  name: 'gate-swap'
}
</script>

<template>
  <div class="gate_swap">
    <svg
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 64 64'
      width='64' height='64'
      fill='currentcolor'>
      <path d='M60 0 L32 28 L4 0 L0 4 L28 32 L0 60 L4 64 L32 36 L60 64 L64 60 L36 32 L64 4' />
    </svg>
  </div>
</template>

<style>
</style>
